import urlBuilder from "app/umbraco/helpers/urlBuilder";
import getClosestWidthTier from "app/media/helpers/getClosestWidthTier";
import { UmbracoImageCrop, UmbracoImageFocalPoint } from "../models/media.interface";

export default (src: string, clientWidth: number, extensionType?: string, crop?: UmbracoImageCrop, focalPoint?: UmbracoImageFocalPoint, heightRatio?: number): string => {
    const imageUrl = urlBuilder(src);
    const params = new URLSearchParams();

    const imageWidth = getClosestWidthTier(clientWidth);
    if (crop && crop.coordinates) {
        params.set("cc", `${crop.coordinates.x1},${crop.coordinates.y1},${crop.coordinates.x2},${crop.coordinates.y2}`);
        params.set("cropmode", "percentage");
        if (typeof (heightRatio) !== "undefined") {
            params.set("height", (imageWidth * heightRatio).toString());
        }
    }
    else if (focalPoint) {
        params.set("rxy", `${focalPoint.left},${focalPoint.top}`);
        params.set("rmode", "crop");

        if (typeof (heightRatio) !== "undefined") {
            params.set("height", (imageWidth * heightRatio).toString());
        }
    }
    else {
        params.set("rxy", `${0.5},${0.5}`);
        params.set("rmode", "crop");

        if (typeof (heightRatio) !== "undefined") {
            params.set("height", (imageWidth * heightRatio).toString());
        }
    }

    // Search for closest value to only have 5 different image sizes to cache.

    params.set("width", imageWidth.toString());

    params.set("upscale", "true");
    params.set("format", extensionType || "jpg");

    if (extensionType === "jpg" || extensionType === "jpeg") {
        params.set("bgcolor", "white");
    }
    else if (extensionType === "png" || extensionType === "gif") {
        params.set("bgcolor", "transparent");
    }

    // TODO: .WEBP extension

    const querySeparator = imageUrl.toString().indexOf("?") > 0 ? "&" : "?";
    return `${imageUrl}${querySeparator}${params.toString()}`;
};
